import AbstractSideBar from '../AbstractSideBar';
import ElementsTab from '../ElementsTab';
import PlantsTab from '../PlantsTab';
import InfoTab from './InfoTab';
import ListsTab from './ListTab';
import SearchTab from './SearchTab';

export default class SideBar extends AbstractSideBar {
    init() {
        super.init();
        this.tabs = {
            'search': new SearchTab(this.provider, this.tabContainer),
            'lists': new ListsTab(this.provider, this.tabContainer),
            'info': new InfoTab(this.provider, this.tabContainer),
            'elements': new ElementsTab(this.provider, this.tabContainer),
            'plants': new PlantsTab(this.provider, this.tabContainer),
        };

        this.tabContainer.size(this.labelWidth, this.labelHeight * Object.keys(this.tabs).length);
    }

    activate() {
        this.openTab = this.tabs['search'];
        this.openTab.activate();
    }
}
